// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2v5As","footer":"Form_footer__1jVTj"};